import Text from 'core-system/Text'
import palette from 'core-system/Themes/palette'
import React from 'react'
import styled from 'styled-components'
import { ComplianceOverviewArea } from 'redux/compliance/complianceTypes'
import WorksiteComplianceCard from './WorksiteComplianceCard'

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1.5rem;
  align-items: start;

  @media (max-width: ${(props) => props.theme.breakpoints[3]}) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
    grid-template-columns: 1fr;
  }
`

const EmptyState = styled.div`
  ${(props) => props.theme.baseCard}
  padding: 2rem;
`

interface ComplianceAreaCardsProps {
  areas: ComplianceOverviewArea[]
}

const ComplianceAreaCards = React.memo((props: ComplianceAreaCardsProps) => {
  const { areas } = props

  if (!areas.length) {
    return (
      <EmptyState>
        <Text variant='body1' color={palette.text.secondary}>
          No compliance areas matched to your worksites yet.
        </Text>
      </EmptyState>
    )
  }

  return (
    <Grid>
      {areas.map((area) => (
        <WorksiteComplianceCard key={area.id} area={area} />
      ))}
    </Grid>
  )
})

// Helps to identify component in React error logs
if (process.env.NODE_ENV !== 'production') {
  ComplianceAreaCards.displayName = 'ComplianceAreaCards'
}

export default ComplianceAreaCards
